import { c as _c } from "react/compiler-runtime";
import { IcoCheckCircle16, IcoWarning16 } from '@onefootprint/icons';
import { LoadingSpinner } from '@onefootprint/ui';
import { extractToolResultText } from '../../utils/tool-result';
type MetaCreateInvestigationCallProps = {
  input: Record<string, unknown>;
  toolResult?: string;
  /** True when this tool_use's result came back with `is_error=true`. */
  toolResultIsError?: boolean;
  /** Suppress the leading icon when rendered on a tool-call timeline rail (the rail owns it). */
  hideIcon?: boolean;
};

// A successful result is JSON carrying a non-empty `investigation_id`; backend errors are plain
// text (e.g. "HTTP error 403: ...") and parse to null.
const parseInvestigationResult = (raw?: string): {
  investigation_id: string;
} | null => {
  const text = extractToolResultText(raw);
  if (!text) return null;
  try {
    const parsed = JSON.parse(text) as {
      investigation_id?: unknown;
    };
    const id = typeof parsed?.investigation_id === 'string' ? parsed.investigation_id.trim() : '';
    return id ? {
      investigation_id: id
    } : null;
  } catch {
    return null;
  }
};
const MetaCreateInvestigationCall = t0 => {
  const $ = _c(27);
  const {
    input,
    toolResult,
    toolResultIsError,
    hideIcon
  } = t0;
  let t1;
  if ($[0] !== input.title) {
    t1 = typeof input.title === "string" ? input.title.trim() : "";
    $[0] = input.title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const title = t1;
  if (!toolResult) {
    let t2;
    if ($[2] !== hideIcon) {
      t2 = !hideIcon && <LoadingSpinner size="default" color="tertiary" className="shrink-0 mt-px" />;
      $[2] = hideIcon;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <span className="text-shimmer">Starting investigation</span>;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    let t4;
    if ($[5] !== t2) {
      t4 = <div className="flex items-start gap-2 text-caption-1 text-tertiary py-1">{t2}{t3}</div>;
      $[5] = t2;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    return t4;
  }
  const result = parseInvestigationResult(toolResult);
  const isError = !!toolResultIsError || !result;
  if (isError) {
    let t2;
    if ($[7] !== hideIcon) {
      t2 = !hideIcon && <span className="shrink-0 flex items-center h-[1.25em]"><IcoWarning16 color="error" /></span>;
      $[7] = hideIcon;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    let t3;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <span className="text-error font-medium">Couldn't start investigation</span>;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    let t4;
    if ($[10] !== title) {
      t4 = title && <span className="font-mono text-caption-2 truncate">{title}</span>;
      $[10] = title;
      $[11] = t4;
    } else {
      t4 = $[11];
    }
    let t5;
    if ($[12] !== t4) {
      t5 = <div className="flex flex-col gap-1 min-w-0">{t3}{t4}</div>;
      $[12] = t4;
      $[13] = t5;
    } else {
      t5 = $[13];
    }
    let t6;
    if ($[14] !== t2 || $[15] !== t5) {
      t6 = <div className="flex items-start gap-1.5 text-caption-1 text-error py-1">{t2}{t5}</div>;
      $[14] = t2;
      $[15] = t5;
      $[16] = t6;
    } else {
      t6 = $[16];
    }
    return t6;
  }
  let t2;
  if ($[17] !== hideIcon) {
    t2 = !hideIcon && <span className="shrink-0 flex items-center h-[1.25em]"><IcoCheckCircle16 className="text-primary" /></span>;
    $[17] = hideIcon;
    $[18] = t2;
  } else {
    t2 = $[18];
  }
  let t3;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="text-secondary">Investigation started</span>;
    $[19] = t3;
  } else {
    t3 = $[19];
  }
  let t4;
  if ($[20] !== title) {
    t4 = title && <span className="font-mono text-caption-2 truncate">{title}</span>;
    $[20] = title;
    $[21] = t4;
  } else {
    t4 = $[21];
  }
  let t5;
  if ($[22] !== t4) {
    t5 = <div className="flex flex-col gap-1 min-w-0">{t3}{t4}</div>;
    $[22] = t4;
    $[23] = t5;
  } else {
    t5 = $[23];
  }
  let t6;
  if ($[24] !== t2 || $[25] !== t5) {
    t6 = <div className="flex items-start gap-1.5 text-caption-1 text-tertiary py-1">{t2}{t5}</div>;
    $[24] = t2;
    $[25] = t5;
    $[26] = t6;
  } else {
    t6 = $[26];
  }
  return t6;
};
export default MetaCreateInvestigationCall;